(ns teamoesterreich.admin-mode.lebensretter.incident.small-lr-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as vstate]
            [reagent-material-ui.icons.alternate-email :as ic-email]
            [reagent-material-ui.icons.info :as ic-info]
            [reagent-material-ui.icons.location-searching :as ic-location-searching]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]))





(defn date-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      (if (> (count cell-data) 10)
        [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
         [:br]
         (str (subs cell-data 9 11) ":" (subs cell-data 11 13) ":" (subs cell-data 13 15))
         ]
        [:span "-"]))))

(defn message-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:div {:style {:fontSize "small"}
             :title cell-data} cell-data])))


(defn lebensretter-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(println "email-cell-renderer " cell-data)
    (r/as-element
      [:div {:style {:fontSize "small"}}
       (for [intervention cell-data]
         ^{:key (str "int-" (get intervention "intervention-uuid"))}
         [:div {:style {:text-align "left" :border "1px red solid"}} (str (get intervention "toe-toeId") "\n" (get intervention "toe-email"))])
       ])))


(defn edit-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/icon-button {:label   "bearbeiten"
                          :onClick #(swap! !st assoc :popup cell-data)
                          } [ic-info/info {:fontSize "small"}]]))))

(defn center-map-renderer [!st]
  (let [!selected (r/cursor !st [:selected])]
    ;(println "center-map-renderer  "  @!selected)
    (fn [js-parm]
      (let [{{lat "incident-latitude" lng "incident-longitude" uuid "incident-uuid"} "rowData" :as d} (js->clj js-parm)]
        (r/as-element
          [mui/icon-button
           {:onClick (fn [_ val]
                       (reset! !selected uuid)
                       (swap! !st assoc-in [:center-map] {:lat lat :lng lng :zoom 17 :mark uuid}))
            } [ic-location-searching/location-searching {:fontSize "small" :color (if (= uuid @!selected) "primary" "inherit")}]
           ])))))


(defn table [!st]
  (let [!sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        !rows (r/cursor !st [:rows])
        ]
    (fn [m]
      (r/as-element
        [:> rv/Table
         {:headerHeight     40
          :height           500
          :rowCount         (count @!rows)
          :rowGetter        (fn [i]
                              ;(println (str "rowGet " (aget i "index")))
                              (clj->js (nth @!rows (aget i "index"))))
          :rowClassName     (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort             (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy           @!sort
          :sortDirection    (if @!reverse "DESC" "ASC")
          :rowHeight        80
          :width            (if m (aget m "width") 397)
          :onRowDoubleClick (fn [i]
                              (let [user (nth @!rows (aget i "index"))]
                                (swap! !st assoc-in [:center-map] {:lat (get user "incident-latitude") :lng (get user "incident-longitude")})
                                ))


          :headerClassName  "headerColumn"
          :className        "SmallToeList"}

         [:> rv/Column
          {:label        "Zeit"
           :dataKey      "incident-date"
           :className    "bordered exampleColumn"
           :cellRenderer date-cell-renderer
           :style        #js {:overflow "hidden" :text-align "left"}
           :width        150}]

         [:> rv/Column
          {:label     "Nummer"
           :dataKey   "incident-external-id"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :text-align "left"}
           :width     150}]
         [:> rv/Column
          {:label        "Text"
           :dataKey      "incident-message"
           :className    "bordered exampleColumn"
           :cellRenderer message-cell-renderer
           :style        #js {:overflow "hidden"}
           :width        170}]
         [:> rv/Column
          {:label        "Lebensretter"
           :dataKey      "intervention"
           :cellRenderer lebensretter-cell-renderer
           :className    "bordered exampleColumn"
           :width        270}]
         [:> rv/Column
          {:label        (r/as-element [ic-info/info])
           :dataKey      "incident-uuid"
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !st)
           :width        60}]
         [:> rv/Column
          {:label        (r/as-element [ic-location-searching/location-searching])
           :dataKey      "email"
           :className    "bordered exampleColumn"
           :cellRenderer (center-map-renderer !st)
           :width        60} [:a {:href ""}]]]
        ))))


(defn autoSizer-table [!st]
  [:> rv/AutoSizer
   {:style {:height "550px" :width "100%"}
    :sort  (str "rerender !st" @!st)}
   (table !st)])